import ResumeReducer from './ResumeReducer'
import ProjectsReducer from './ProjectsReducer'
import ExperienceReducer from './ExperienceReducer'
import CarouselReducer from './CarouselReducer'
import { combineReducers } from 'redux'

export const reduxApp = combineReducers({ResumeReducer, ProjectsReducer, ExperienceReducer, CarouselReducer})
export default reduxApp


// WEBPACK FOOTER //
// ./app/reducers/RootReducer.js